import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Accordion from 'react-bootstrap/Accordion';

const CustomAccordion = ({ children }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = index => {
    setActiveTab(index);
  };

  return (
    <>
      <Accordion defaultActiveKey={'0'}>
        {React.Children.map(children, (child, index) => (
          <Accordion.Item eventKey={'' + index}>
            <Accordion.Header>{child.props.title}</Accordion.Header>
            <Accordion.Body>{child}</Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </>
  );
};

CustomAccordion.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CustomAccordion;
